import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL

class InstituteApi {
  getAllInstitutions(config) {
    return axios.get(BASE_URL + "/admin/institution/institutionDetails", config)
  }

  getInstitutionsWithCounts(config) {
    return axios.get(BASE_URL + "/admin/institution/institutionDetailsWithCounts", config)
  }

  getInstitutionsById(id,config) {
    return axios.get(`${BASE_URL}/admin/institution/${id}`, config)
  }

  getInstitutionMenuList(config) {
    return axios.get(
      BASE_URL + "/admin/institution/institutionMenuDetails",
      config,
    )
  }

  addInstitution(data, config) {
    return axios.post(BASE_URL + "/admin/institution/create", data, config)
  }

  updateInstitution(data, config) {
    return axios.put(BASE_URL + "/admin/institution/update", data, config)
  }


  uploadInstitutionByExcel(data, config) {
    return axios.post(BASE_URL + "/admin/institution/uploadInstitution", data, config)
  }

  updateInstitutionStatus(payload, config) {
    return axios.put(
      BASE_URL + "/admin/institution/update-status",
      payload,
      config,
    )
  }
  deleteReview(data, config) {
    return axios.delete(BASE_URL + "/admin/institution/deleteReview", {
      ...config,
      data: data
    })
  }
  searchInstitution(config) {
    return axios.get(BASE_URL + "/admin/institution/searchInstitution", config)
  }
}

export default new InstituteApi()
